var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-select',{model:{value:(_vm.dynamicFormId),callback:function ($$v) {_vm.dynamicFormId=$$v},expression:"dynamicFormId"}},_vm._l((_vm.forms),function(item,index){return _c('vs-select-item',{key:index,attrs:{"value":item.id,"text":item.title}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }